// Session history management
const HISTORY_KEY = 'zenermind_session_history';

export const SessionHistory = {
  saveSession(session) {
    const history = this.getHistory();
    
    const sessionRecord = {
      sessionId: session.sessionId,
      sessionLabel: `Session ${history.length + 1}`,
      dateTime: new Date().toISOString(),
      playerName: session.playerName,
      hits: session.hits,
      total: session.total,
      accuracy: session.total > 0 ? ((session.hits / session.total) * 100).toFixed(1) : '0.0',
      bestStreak: session.bestStreak,
      sessionSeed: session.sessionSeed,
      level: this.calculateLevel(session.hits),
      symbolStats: this.calculateSymbolStats(session.guessHistory),
      guessHistory: session.guessHistory
    };
    
    history.unshift(sessionRecord); // Add to beginning
    
    try {
      localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
    } catch {
      // Storage failed silently
    }
    
    return sessionRecord;
  },
  
  getHistory() {
    try {
      const history = localStorage.getItem(HISTORY_KEY);
      return history ? JSON.parse(history) : [];
    } catch {
      return [];
    }
  },
  
  getSession(sessionId) {
    const history = this.getHistory();
    return history.find(s => s.sessionId === sessionId);
  },
  
  calculateLevel(hits) {
    if (hits <= 6) return 1;
    if (hits <= 9) return 2;
    if (hits <= 12) return 3;
    if (hits <= 15) return 4;
    return 5;
  },
  
  calculateSymbolStats(guessHistory) {
    const symbols = ['circle', 'cross', 'waves', 'square', 'star'];
    const stats = {};
    
    symbols.forEach(symbol => {
      stats[symbol] = {
        guessed: 0,
        actual: 0,
        hits: 0
      };
    });
    
    guessHistory.forEach(guess => {
      const guessedSymbol = guess.guess.toLowerCase();
      const actualSymbol = guess.actual.toLowerCase();
      
      if (stats[guessedSymbol]) {
        stats[guessedSymbol].guessed++;
      }
      
      if (stats[actualSymbol]) {
        stats[actualSymbol].actual++;
      }
      
      if (guess.isHit && stats[guessedSymbol]) {
        stats[guessedSymbol].hits++;
      }
    });
    
    return stats;
  },
  
  clearHistory() {
    localStorage.removeItem(HISTORY_KEY);
  }
};
